
// SVG Icon: refresh
export default { id: "terriajs-refresh" };
export const id = "terriajs-refresh";
export const name = "refresh";
